export enum EnrolmentStatuses {
  Eligible = 1,
  NotEligible = 2,
  NotInterested = 3,
  CallBack = 4,
  LeftMessage = 5,
  BusyUnableToTalk = 6,
  Enrolled = 7
}
